"use client";
import { ContactType, getContactsApi, getSidebarActivitiesApi } from "@/api/config";
import { BannerRep } from "@/api/home";
import Box from "@/components/Box";
import { usePathname, useRouter } from "@/i18n/routing";
import { useSystemStore } from "@/stores/useSystemStore";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { FC, PropsWithChildren, useEffect, useRef, useState } from "react";
import { useSwiper } from "swiper/react";
interface Props {}

const tabs = [
    { name: "casino", id: 1, icon: "pro-niuyouguo" },
    { name: "promocoes", id: 2, icon: "pro-shengriliwu" },
];

enum PageEnum {
    "home",
    "sports",
    "help",
    "promo",
    "deposit",
    "download",
    "none",
}
const Sidebar: FC<PropsWithChildren<Props>> = (props) => {
    const t = useTranslations("Sidebar");

    const swiper = useSwiper();
    const router = useRouter();
    const tab = useRef<HTMLDivElement>(null);
    const bgRef = useRef<HTMLDivElement>(null);

    const pathname = usePathname();
    const { isCollapse, setCollapse } = useSystemStore((state) => ({
        isCollapse: state.isCollapse,
        setCollapse: state.setCollapse,
    }));

    const tabHandler = (index: PageEnum, isAction = true) => {
        bgRef.current?.setAttribute(
            "style",
            `transform: translateX(${tab.current?.clientWidth! * index}px)`
        );
        if (isAction) {
            switch (index) {
                case 0:
                    router.push("/");
                    break;
                case 1:
                    router.push("/promo");
                    break;
                case 2:
                    router.push("/help");
                    break;
                case 3:
                    router.push("/promo");
                    break;
                case 4:
                    router.push("/deposit");
                    break;
                case 5:
                    router.push("/download");
                    break;
            }
            // 关闭侧边栏按钮
            setCollapse(false);
            // 关闭swiper
            // swiper.slideNext();
        }

        return index;
    };

    useEffect(() => {
        if (pathname === "/") {
            tabHandler(PageEnum.home, false);
        } else {
            tabHandler(PageEnum.sports, false);
        }
    }, [isCollapse]);

    const [contacts, setContacts] = useState<ContactType[]>();

    const [cardData, setCardData] = useState<BannerRep[]>([]);
    useEffect(() => {
        getContactsApi().then((res) => {
            setContacts(res.data.filter((item) => item.show_bar === 1));
        });

        getSidebarActivitiesApi().then((res) => {
            console.log(res);
            setCardData(res.data);
        });
    }, []);

    return (
        <Box
            pt={false}
            className={
                "h-[100%] border-[1px] border-[#e540ff] bg-[url(/home/bg.jpg)] shadow-[0_0_10px_0_#e540ff_inset]"
            }
        >
            <div className={"relative h-[100%] overflow-scroll"}>
                <div className={"sticky top-[0]"}>
                    <div className={"mb-[.1rem] flex items-center pt-[10px]"}>
                        <div className={"flex-1"}>
                            <Image src={"/logo2.png"} alt={"logo"} width={140} height={120} />
                        </div>

                        <i
                            className={"iconfont icon-guanbi text-[#a3bcff]"}
                            onClick={() => tabHandler(PageEnum.none)}
                        ></i>
                    </div>

                    {/*tabs*/}
                    <div className={"relative"}>
                        <div
                            className={
                                "relative flex rounded bg-[url(/home/side1.png)] bg-[length:100%_100%]"
                            }
                        >
                            {tabs.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => tabHandler(index)}
                                        className={
                                            "z-20 flex h-[0.3056rem] flex-1 justify-center" +
                                            " cursor-pointer items-center text-[#deffff]"
                                        }
                                        ref={tab}
                                    >
                                        <span
                                            className={
                                                `pro-iconfont ${item.icon} mr-[0.05rem] text-[20px]` +
                                                `${index == 0 ? " text-[#1cfffc]" : ""}`
                                            }
                                        ></span>
                                        <span
                                            className={
                                                `` + `${index == 0 ? " text-[#1cfffc]" : ""}`
                                            }
                                        >
                                            {t(item.name)}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            ref={bgRef}
                            style={{ transform: "translateX(0)" }}
                            className={`absolute bottom-[-.06rem] left-[-.04rem] top-[-.04rem] z-10 w-[50%] rounded bg-[url(/home/side2.png)] bg-[length:100%_100%] transition-transform duration-300`}
                        ></div>
                        <div
                            className={`absolute -top-[3px] right-[10px] z-20 w-[0.14rem] text-primary-color`}
                        >
                            <img
                                src="data:image/png;base64,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"
                                alt=""
                            />
                        </div>
                    </div>
                </div>

                {/*  card*/}
                <div className={"mt-[0.2rem] grid grid-cols-1 gap-[0.0833rem]"}>
                    {cardData.map((item, index) => {
                        return (
                            <Box
                                className={"shadow-md"}
                                none={true}
                                key={index}
                                onBeforeHandler={() => {
                                    // 关闭侧边栏按钮
                                    setCollapse(false);
                                    // 关闭swiper
                                    // swiper.slideNext();
                                }}
                                action={item.action_type}
                                actionData={item.action_params}
                            >
                                <div className="mb-[.1rem] flex h-[0.5556rem] justify-center overflow-hidden rounded-[0.1rem] border-[1px] border-[#eba9ff]">
                                    <img
                                        src={item.content}
                                        alt=""
                                        className={"h-[100%] w-[100%]"}
                                    />
                                </div>
                            </Box>
                        );
                    })}
                </div>

                {/*  gift */}
                {/*<section*/}
                {/*    onClick={() => tabHandler(PageEnum.promo)}*/}
                {/*    className={"my-[0.11rem] flex items-center text-[0.15rem]" + " text-[#fff]"}*/}
                {/*>*/}
                {/*    <div className={"flex-1"}>*/}
                {/*        <span*/}
                {/*            className={*/}
                {/*                "iconfont icon-liwulipinjiangpin mr-[0.0694rem]" +*/}
                {/*                " text-[0.16rem] text-[#999]"*/}
                {/*            }*/}
                {/*        ></span>*/}
                {/*        <span> {t("promocoes")} </span>*/}
                {/*    </div>*/}
                {/*    /!*<span className={"iconfont icon-xiangyou1"}></span>*!/*/}
                {/*</section>*/}

                <section
                    onClick={() => tabHandler(PageEnum.deposit)}
                    className={"my-[0.16rem] flex items-center text-[0.15rem]" + " text-[#fff]"}
                >
                    <div className={"flex-1"}>
                        <span
                            className={
                                "iconfont icon-qianbao3 mr-[0.0694rem] text-[0.16rem] text-[#fff]"
                            }
                        ></span>
                        <span> {t("deposit")} </span>
                    </div>
                    {/*<span className={"iconfont icon-xiangyou1"}></span>*/}
                </section>

                <section
                    onClick={() => tabHandler(PageEnum.help)}
                    className={"my-[0.16rem] flex items-center text-[0.15rem]" + " text-[#fff]"}
                >
                    <div className={"flex-1"}>
                        <span
                            className={
                                "iconfont icon-bangzhu mr-[0.0694rem] text-[0.16rem] text-[#fff]"
                            }
                        ></span>
                        <span> {t("ajude")} </span>
                    </div>
                    {/*<span className={"iconfont icon-xiangyou1"}></span>*/}
                </section>
                <section
                    onClick={() => tabHandler(PageEnum.download)}
                    className={"my-[0.16rem] flex items-center text-[0.15rem]" + " text-[#fff]"}
                >
                    <div className={"flex-1"}>
                        <span
                            className={
                                "iconfont icon-header-18 mr-[0.0694rem] text-[0.16rem] text-[#fff]"
                            }
                        ></span>
                        <span> {t("download")} </span>
                    </div>
                    {/*<span className={"iconfont icon-xiangyou1"}></span>*/}
                </section>

                <section className={"text-[0.15rem]" + " text-[#fff]"}>
                    {contacts?.map((item, index) => (
                        <a
                            key={index}
                            href={`mailto:${item.email}`}
                            className={"my-[0.16rem] flex items-center text-[#fff]"}
                        >
                            <span
                                className={
                                    "iconfont icon-duanxinguanli mr-[0.09rem] text-[0.16rem] text-[#fff]"
                                }
                            ></span>
                            <span> {t("email")} </span>
                        </a>
                    ))}
                </section>

                {/*  Esportes */}
                {/*<section*/}
                {/*    className={"flex items-center rounded-[3px] bg-[#3a3a3a] p-[0.08rem] text-[#fff]"}*/}
                {/*    onClick={() => tabHandler(1)}*/}
                {/*>*/}
                {/*    <i className={"iconfont icon-tiyu mr-[0.0694rem] text-[0.15rem]"}></i>*/}
                {/*    <div className={"flex-1"}>{t("esportes")}</div>*/}
                {/*    <i className={"iconfont icon-xiangyou1 text-[0.15rem]"}></i>*/}
                {/*</section>*/}
                {/*  code */}
                {/*<section className={"mt-[0.11rem] text-[#fff]"}>{t("promoCode")}</section>*/}
                {/*<section className={"w-1/1 mt-[0.11rem] flex"}>*/}
                {/*    <div className={"flex-1 bg-[#3a3a3a] p-[0.0694rem]" + " text-[#fff]"}>*/}
                {/*        <Input*/}
                {/*            placeholder={t("codeInputPlaceHolder")}*/}
                {/*            clearable*/}
                {/*            className={"text-[#fff]"}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <button*/}
                {/*        className={`w-[0.6rem] bg-gradient-to-b from-[#a28362] to-[#986847] text-[0.12rem] text-[#fff]`}*/}
                {/*    >*/}
                {/*        {t("promoButton")}*/}
                {/*    </button>*/}
                {/*</section>*/}

                <section className={"mt-[0.11rem] text-[#fff]"}>{t("coumnidade")}</section>

                <section className={"mt-[0.11rem] text-[#fff]"}>
                    {/* <Media /> */}
                    {/*<div*/}
                    {/*    className={`grid`}*/}
                    {/*    style={{*/}
                    {/*        gridTemplateColumns: ` repeat(${socials.length >= 5 ? 5 : socials.length},1fr)`,*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {socials.map((service, index) => {*/}
                    {/*        return (*/}
                    {/*            <Link*/}
                    {/*                key={index}*/}
                    {/*                href={service.url}*/}
                    {/*                target={"_blank"}*/}
                    {/*                className="bg-white m-[0.05rem] h-[0.3889rem] w-[0.3889rem] rounded"*/}
                    {/*            >*/}
                    {/*                <img*/}
                    {/*                    className={"h-[0.3889rem] w-[0.3889rem]"}*/}
                    {/*                    src={service.icon_url}*/}
                    {/*                ></img>*/}
                    {/*            </Link>*/}
                    {/*        );*/}
                    {/*    })}*/}
                    {/*</div>*/}
                </section>

                {/*<section className={"flex justify-between p-[0.08rem] text-[12px] text-[#7d7d7d]"}>*/}
                {/*    <span>Version</span>*/}
                {/*    <span>0.0.2</span>*/}
                {/*</section>*/}
            </div>
        </Box>
    );
};

export default Sidebar;
